import Override from '../../../Core/mixin/Override.js';
import PdfExport from '../../feature/export/PdfExport.js';

Override.apply(class PdfExportOverride {
    static target = {
        class : PdfExport
    }

    // For salesforce we only need to load bryntum theme which is somewhere in the static resources
    onPrintIFrameLoad(iframe) {
        const doc = iframe.contentDocument;

        // DOM Parser is salesforce filters out `link` tag, we need to grab it from source window
        Array.from(document.querySelectorAll('link[href*="/resource/"]')).forEach(link => {
            const el = doc.importNode(link);
            el.setAttribute('href', link.href);
            doc.head.appendChild(el);
        });
    }
});
